import EnvironmentImage from "../assets/images/new/banner_2.png";
import MechanicalImg from "../assets/images/mechanical.png";
import ElectricalImg from "../assets/images/electrical.png";

import RentCemsOne from "../assets/images/rent_cems/1.webp";
import RentCemsTwo from "../assets/images/rent_cems/2.webp";
import RentCemsThree from "../assets/images/rent_cems/3.webp";

import MechaOne from "../assets/images/mechanical_service_image/1.webp";
import MechaTwo from "../assets/images/mechanical_service_image/2.webp";
import MechaThree from "../assets/images/mechanical_service_image/3.webp";

import EnvOne from "../assets/images/environment_service_image/1.webp";
import EnvTwo from "../assets/images/environment_service_image/2.webp";
import EnvThree from "../assets/images/environment_service_image/3.webp";
import EnvFour from "../assets/images/environment_service_image/4.webp";
import EnvFive from "../assets/images/environment_service_image/5.webp";
import EnvSix from "../assets/images/environment_service_image/6.webp";
import EnvSeven from "../assets/images/environment_service_image/7.webp";
import EnvEight from "../assets/images/environment_service_image/8.webp";

export const serviceImage = {
  imgEnv: EnvironmentImage,
  imgMech: MechanicalImg,
  imgElec: ElectricalImg,
};

export const serviceImgRentCems: string[] = [
  RentCemsOne,
  RentCemsTwo,
  RentCemsThree,
];

export const serviceImgMechanical: string[] = [MechaOne, MechaTwo, MechaThree];

export const serviceImgEnvironment: string[] = [
  EnvOne,
  EnvTwo,
  EnvThree,
  EnvFour,
  EnvFive,
  EnvSix,
  EnvSeven,
  EnvEight,
];
